export const sdkUrl =
  'https://raw.githubusercontent.com/Aicade/games-console/main/src/lib/braincadeSDK.js'
export const vfxUrl =
  'https://raw.githubusercontent.com/ks-braincade/braincadeSDK/main/src/vfxLibrary.js'
export const phaserUrl =
  'https://cdnjs.cloudflare.com/ajax/libs/phaser/3.80.1/phaser.min.js'
export const JoystickUrl =
  'https://cdn.jsdelivr.net/gh/rexrainbow/phaser3-rex-notes@master/dist/rexvirtualjoystickplugin.min.js'
export const ButtonUrl =
  'https://cdn.jsdelivr.net/gh/rexrainbow/phaser3-rex-notes@master/dist/rexbuttonplugin.min.js'

export const displayScreenConstants = {
  gameOver: 'GAME_OVER',
  mainMenu: 'MAIN_MENU',
  start: 'START',
  splash: 'SPLASH',
  game: 'GAME',
}

export const GAME_FETCH_DURATION = 40

export const discordLink = 'https://discord.gg/5WutWSMWXr'

export const EDITOR_CONSTANTS = {
  DIMENSIONS: {
    DEFAULT_WIDTH: 315,
    DEFAULT_HEIGHT: 225,
    CONTAINER_MAX_WIDTH: 350,
    CONTAINER_MAX_HEIGHT: 250,
    SCALE_FACTOR: 0.9,
  },
  TIMING: {
    ROTATION_DEBOUNCE_MS: 800,
    CANVAS_CAPTURE_DELAY_MS: 100,
    ROTATION_INTERVAL_MS: 100,
  },
  BACKGROUND: {
    CROSSHATCH_SIZE: 18,
    OPACITY: 0.12,
  },
  ICONS: {
    SIZE: 16,
  }
} as const
